import styled from "styled-components";

export const NoApplicationsCard = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    background-color: #ccc;

    border: 1px solid var(--color-alternative);
    border-radius: 4px;

    height: 100px;
    margin-bottom: 8px;

    font-weight: bold;
    font-size: 1.2rem;
    color: #575757;
`;
